<template>
  <div class="vacancy-description relative">
    <div
      v-if="!vacancyCreated"
      class="card-disable-cover _white"
      @click="$emit('click:disable-cover', $event)"
    ></div>

    <div class="vacancy-description__section edit-group">
      <div class="edit-group__head _blue">
        <h4 class="edit-group__title">
          {{ $tNewVacancy2('about') }}
        </h4>
      </div>
      <div class="edit-group__card">
        <TranslateFiled
          ref="input-about"
          :label="$tNewVacancy2('in free form')"
          rows="10"
          textarea
          editor
          :use-translate-buttons="useFieldsTranslations"
          :use-editor-headings="useEditorsHeadings"
          :original-locale="originalLocale"
          :value="inputs.about.value"
          :error="inputs.about.error"
          @input="changeAction('about', 'setInputValue', ['about', $event])"
          @blur="saveAction('about', ['about', $event])"
          class="_white _shadow"
        />
      </div>
    </div>

    <div class="vacancy-description__section edit-group" data-edit-group="7">
      <div class="edit-group__head _blue">
        <h4 class="edit-group__title">
          {{ $tNewVacancy2('Work place information') }}
        </h4>
      </div>

      <div class="edit-group__media">
        <div class="edit-group__media-col">
          <div class="edit-group__row">
            <BaseInput
              ref="input-work_place_name"
              :value="inputs.work_place_name.value"
              :error="inputs.work_place_name.error"
              :placeholder="$tNewVacancy2('placeholder_work_place_name')"
              @input="changeAction('work_place_name', 'setInputValue', ['work_place_name', $event])"
              class="edit-group__item"
              :label="$tNewVacancy2('work_place_name')"/>
          </div>

          <div v-if="!notActive"
               class="edit-group__row">
            <BaseInput
              ref="input-work_place_code"
              :value="inputs.work_place_code.value"
              :error="inputs.work_place_code.error"
              :placeholder="$tNewVacancy2('placeholder_work_place_code')"
              type="number"
              @input="changeAction('work_place_code', 'setInputValue', ['work_place_code', $event])"
              class="edit-group__item _edit-not-active"
              :label="$tNewVacancy2('work_place_code')"/>
          </div>
        </div>
        <EditDescriptionCompanyLogo/>
      </div>

      <div class="edit-group__row">
        <div class="edit-group__item">
          <SCountry
            ref="input-work_place_country"
            :value="inputs.work_place_country.value"
            :error="inputs.work_place_country.error"
            prefetch
            :placeholder="$tNewVacancy2('placeholder_work_place_country')"
            @input="changeAction('work_place_country', 'setInputValue', ['work_place_country', $event])"
            :label="$tNewVacancy2('work_place_country')"/>
        </div>
        <div class="edit-group__item">
          <SCity
            ref="input-work_place_city"
            :countryId="inputs.work_place_country.value && inputs.work_place_country.value.id || inputs.work_place_country.value"
            :value="inputs.work_place_city.value"
            :error="inputs.work_place_city.error"
            prefetch
            disabled-on-empty-list
            :disabled="!inputs.work_place_country.value"
            :placeholder="$tNewVacancy2('placeholder_work_place_city')"
            @input="changeAction('work_place_city', 'setInputValue', ['work_place_city', $event])"
            :label="$tNewVacancy2('work_place_city')"/>
        </div>
      </div>

      <div class="edit-group__row">
        <MapPicker
          ref="input-work_place_address"
          :value="inputs.work_place_address.value"
          :label="$tNewVacancy2('Locality')"
          onlyButton
          :placeholder="$tNewVacancy2('placeholder_map')"
          @input="changeValueAddress"
          class="edit-group__item"/>
      </div>

      <div class="edit-group__row">
        <div ref="input-work_place_description" class="edit-group__item">
          <div class="edit-group__label">
            <BaseTooltip
              :text="$tNewVacancy2('work_place_description_tooltip')"
              class="vacancy-section-basic__tooltip"
            >
              <template v-slot:activator>
                  <span class="vacancy-section-basic__tooltip-question">
                    ?
                  </span>
              </template>
            </BaseTooltip>
            <span>{{ $tNewVacancy2('work_place_description') }}</span>
            <SwitchCheckbox
              :value="!inputs.work_place_description.disabled"
              :label="$tNewVacancy2('Specify a workplace description')"
              class="_blue"
              @input="toggleDisabled('work_place_description', $event)"
            />
          </div>
          <div v-if="!inputs.work_place_description.disabled" class="edit-group__card">
            <TranslateFiled
              :label="$tNewVacancy2('in free form')"
              rows="10"
              textareawork_place_description
              editor
              :use-translate-buttons="useFieldsTranslations"
              :use-editor-headings="useEditorsHeadings"
              :original-locale="originalLocale"
              :value="inputs.work_place_description.value"
              :error="inputs.work_place_description.error"
              @input="changeAction('work_place_description', 'setInputValue', ['work_place_description', $event])"
              @blur="saveAction('work_place_description', ['work_place_description', $event])"
              class="_white _shadow"
            />
            <div v-if="!notActive"
                 class="edit-group__card-files _edit-not-active">
              <div class="edit-group__label">
                {{ $tNewVacancy2('Work place photo') }}
              </div>
              <EditFilesDraggable
                ref="input-work_place_files"
                :value="workPaceFiles"
                :pending="workPaceFilesPending"
                :pending-edit="workPaceFilesEditPending"
                :error="workPaceFilesError"
                :with-caption="false"
                @input="uploadFilesByKey(['workPaceFiles', 'work_place_files', $event])"
                @update="updateFilesByKey(['workPaceFiles', 'work_place_files', $event])"
                @delete="deleteFilesByKey(['workPaceFiles', 'work_place_files', $event])"
              />
            </div>
          </div>
        </div>
      </div>

      <div v-if="!notActive"
           class="edit-group__row _edit-not-active">
        <div class="edit-group__item">
          <div class="edit-group__label">
            {{ $tNewVacancy2('work_place_conditions') }}
          </div>
          <div class="edit-group__card">
            <TranslateFiled
              ref="input-work_place_conditions"
              :label="$tNewVacancy2('in free form')"
              rows="10"
              textarea
              editor
              :use-translate-buttons="useFieldsTranslations"
              :use-editor-headings="useEditorsHeadings"
              :original-locale="originalLocale"
              :value="inputs.work_place_conditions.value"
              :error="inputs.work_place_conditions.error"
              @input="changeAction('work_place_conditions', 'setInputValue', ['work_place_conditions', $event])"
              @blur="saveAction('work_place_conditions', ['work_place_conditions', $event])"
              class="_white _shadow"
            />
            <div class="edit-group__card-files">
              <div class="edit-group__label">
                {{ $tNewVacancy2('Work place conditions photo') }}
              </div>
              <EditFilesDraggable
                ref="input-work_place_conditions_files"
                :value="workPaceConditionsFiles"
                :pending="workPaceConditionsFilesPending"
                :pending-edit="workPaceConditionsFilesEditPending"
                :error="workPaceConditionsFilesError"
                :with-caption="false"
                @input="uploadFilesByKey(['workPaceConditionsFiles', 'work_place_conditions_files', $event])"
                @update="updateFilesByKey(['workPaceConditionsFiles', 'work_place_conditions_files', $event])"
                @delete="deleteFilesByKey(['workPaceConditionsFiles', 'work_place_conditions_files', $event])"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="edit-group__row">
        <div ref="input-work_place_procedures" class="edit-group__item">
          <div class="edit-group__label">
            <span>{{ $tNewVacancy2('work_place_procedures') }}</span>
            <SwitchCheckbox
              :value="!inputs.work_place_procedures.disabled"
              :label="$tNewVacancy2('Specify a description')"
              class="_blue"
              @input="toggleDisabled('work_place_procedures', $event)"
            />
          </div>
          <div v-if="!inputs.work_place_procedures.disabled" class="edit-group__card">
            <TranslateFiled :label="$tNewVacancy2('in free form')"
                            rows="10"
                            textarea
                            editor
                            :use-translate-buttons="useFieldsTranslations"
                            :use-editor-headings="useEditorsHeadings"
                            :original-locale="originalLocale"
                            :value="inputs.work_place_procedures.value"
                            :error="inputs.work_place_procedures.error"
                            @input="changeAction('work_place_procedures', 'setInputValue', ['work_place_procedures', $event])"
                            @blur="saveAction('work_place_procedures', ['work_place_procedures', $event])"
                            class="_white _shadow"
            />
            <div v-if="!notActive"
                 class="edit-group__card-files  _single _edit-not-active">
              <div class="edit-group__label">
                {{ $tNewVacancy2('Work registration procedure video') }}
              </div>
              <EditFilesDraggable ref="input-work_place_procedure_files"
                                  :value="workPaceProcedureFiles"
                                  :pending="workPaceProcedureFilesPending"
                                  :pending-edit="workPaceProcedureFilesEditPending"
                                  :error="workPaceProcedureFilesError"
                                  :max="1"
                                  :with-caption="false"
                                  @input="uploadFilesByKey(['workPaceProcedureFiles', 'work_place_procedure_files', $event])"
                                  @update="updateFilesByKey(['workPaceProcedureFiles', 'work_place_procedure_files', $event])"
                                  @delete="deleteFilesByKey(['workPaceProcedureFiles', 'work_place_procedure_files', $event])"
              />
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="vacancy-description__section edit-group">
      <div class="edit-group__head _blue">
        <h4 class="edit-group__title">
          {{ $tNewVacancy2('download_media') }}
        </h4>
      </div>
      <EditFilesDraggable
        ref="input-media"
        :value="photoAndVideoFiles"
        :pending="photoAndVideoFilesPending"
        :pending-edit="photoAndVideoFilesEditPending"
        :error="photoAndVideoFilesError"
        @input="uploadPhotoAndVideo($event)"
        @update="updatePhotoAndVideo($event)"
        @delete="deleteFilePhotoAndVideo($event)"
      />
    </div>

    <div class="vacancy-description__section edit-group">
      <div class="edit-group__head _blue">
        <h4 class="edit-group__title">
          {{ $tNewVacancy2('download_files') }}
        </h4>
      </div>
      <VacancyEditFiles
        ref="input-files"
        :value="additionalDocument"
        :error="additionalDocumentError"
        :pending="additionalDocumentPending"
        @input="uploadAdditionalFiles($event)"
        @delete="deleteAdditionalFiles($event)"
      />
    </div>

    <div class="relative vacancy-description__section edit-group" data-edit-group="10">
      <!--   Using for scroll targets   -->
      <div ref="input-features_1" class="absolute" style="height: 50%; width: 100%; z-index: -1"></div>
      <div ref="input-features_2" class="absolute" style="height: 100%; width: 100%; z-index: -1"></div>
      <div ref="input-features_3" class="absolute" style="height: 150%; width: 100%; z-index: -1;"></div>
      <VacancyEditFeatures />
    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
  import TranslateFiled from '../TranslateFiled'
  import VacancyEditFiles from './VacancyEditFiles'
  import EditFilesDraggable from './EditFilesDraggable'
  import MapPicker from './MapPicker'
  import VacancyEditFeatures from './VacancyEditFeatures'
  import EditDescriptionCompanyLogo from './EditDescriptionCompanyLogo'
  import SCountry from '../loadingSelects/SCountry'
  import SCity from '../loadingSelects/SCity'
  import SwitchCheckbox from '../SwitchCheckbox';
  import fileUploadMixin from '../../mixins/fileUploadMixin'
  import {VIDEOS_TYPES} from '@/constants/files'

  let timer = null

  export default {
    name: 'EditDescription',
    components: {
      VacancyEditFeatures,
      EditDescriptionCompanyLogo,
      MapPicker,
      EditFilesDraggable,
      TranslateFiled,
      VacancyEditFiles,
      SCountry,
      SCity,
      SwitchCheckbox,
    },
    mixins: [fileUploadMixin],
    props: {
      vacancyCreated: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        notActive: true // hide
      }
    },
    computed: {
      ...mapState('vacancyEdit/sectionDescription', [
        'inputs',
        'companyLogo',
        'photoAndVideoFiles',
        'photoAndVideoFilesPending',
        'photoAndVideoFilesError',
        'photoAndVideoFilesEditPending',
        'additionalDocument',
        'additionalDocumentPending',
        'additionalDocumentError',

        'workPaceFiles',
        'workPaceFilesPending',
        'workPaceFilesEditPending',
        'workPaceFilesError',

        'workPaceConditionsFiles',
        'workPaceConditionsFilesPending',
        'workPaceConditionsFilesEditPending',
        'workPaceConditionsFilesError',

        'workPaceProcedureFiles',
        'workPaceProcedureFilesPending',
        'workPaceProcedureFilesEditPending',
        'workPaceProcedureFilesError',
      ]),
      ...mapGetters('vacancyEdit', [
        'originalLocale',
        'afterJustCreated',
        'savedBlocks',
      ]),
      ...mapGetters('user', [
        'isOur',
        'employerProfile',
      ]),
      typeFilesWorkPlaceProcedure() {
        const typesString = VIDEOS_TYPES.join(', .')
        return '.' + typesString
      },
      useFieldsTranslations() {
        return this.isOur && this.savedBlocks?.[1] === true && !this.afterJustCreated;
      },
      useEditorsHeadings() {
        return false;
      },
    },
    async mounted() {
      const interval = setInterval(() => {
        if (this.employerProfile.name) {
          this.applyDefaultValues();
          this.saveSection().then(() => {
            this.applyDefaultDisabled();
          });

          clearInterval(interval);
        }
      }, 700);
    },
    methods: {
      ...mapMutations('vacancyEdit/sectionDescription', [
        'setInputValue',
        'setDefaultInputsValues',
        'setDefaultInputsDisabled',
        'setInputDisabled',
      ]),
      ...mapActions('vacancyEdit/sectionDescription', [
        'uploadPhotoAndVideo',
        'deleteFilePhotoAndVideo',
        'updatePhotoAndVideo',
        'uploadAdditionalFiles',
        'deleteAdditionalFiles',

        'uploadFilesByKey',
        'updateFilesByKey',
        'deleteFilesByKey',
      ]),
      saveSection() {
        return this.$store.dispatch('vacancyEdit/saveSection', { sectionName: 'sectionDescription' });
      },
      applyDefaultValues() {
        const entries = [
          ['work_place_name', this.employerProfile.name],
          ['work_place_country', this.employerProfile.country],
        ];
        if (!this.companyLogo) entries.push(['work_place_logo', this.employerProfile.logo]);

        this.setDefaultInputsValues(entries);
      },
      applyDefaultDisabled() {
        const keys = ['work_place_description', 'work_place_procedures'];
        this.setDefaultInputsDisabled(keys);
      },
      toggleDisabled(inputKey, value) {
        this.setInputDisabled([inputKey, !value]);
      },
      saveAction(key, value) {
        let val
        if (value) {
          let values = value['1'].replace(/["'{}]/g, '').replace(/,/g, ', ') || 'empty'
          val = `${values}`
        }
        if (val !== undefined) {
          let str = `Vacancy, Main information. Field: ${key}, value: ${val}`
          this.$store.dispatch('sendAlert', {
            type: 'form',
            title: str
          })
        }

      },
      changeAction(key, method, value) {
        if (method) {
          this[method](value)
        }

        clearTimeout(timer)
        timer = setTimeout(() => {
          this.saveSection();
        }, 1000)
      },
      changeValueAddress(value) {
        this.changeAction('work_place_address', 'setInputValue', ['work_place_address', value])
      },
      upload(files) {
        console.log(files)
        // this.$emit('input', files)
      },
      onDelete(index) {
        console.log(index)
        // this.$emit('delete', index)
      },
    }
  }
</script>

<style>

</style>
